export default "__VITE_ASSET__4613fe52__"